import React from 'react';
import { BsBuildings } from 'react-icons/bs';

const CompanyLogo = ({ logo, companyName }) => {
  return (
    <>
      {logo && (
        <img
          src={`https://career.uwed.uz/api/storage/files/${logo}`}
          alt={companyName}
          style={{ objectFit: 'cover' }}
          width={'64px'}
          height={'64px'}
        />
      )}
      {!logo && <BsBuildings style={{ color: '#882e2e' }} size={48} />}
    </>
  );
};

export default CompanyLogo;
